import mixpanel from 'mixpanel-browser';

const token = __MIXPANEL_TOKEN__;

if (token) {
  mixpanel.init(token, {
    // Stable anonymous distinct_id and super properties (recommended for web).
    persistence: 'localStorage',
    // When `autocapture` is set, SPA page views use `autocapture.pageview`, not this flag.
    track_pageview: false,
    autocapture: {
      // Full URL (path, query, hash) so client-side navigations fire Page View like full reloads.
      pageview: 'full-url',
      click: true,
      capture_text_content: true,
    },
    ip: false,
  });
}

export function trackEvent(event: string, properties: Record<string, string | number>) {
  if (token) {
    mixpanel.track(event, properties);
  }
}
